/* template */
<template><mpx-view @tap="onLoginClick" class="login-control"><div class="left"><div class="label">{{ $t('home.recommendPromoDeal') }}</div></div><div class="right"><span class="label">{{ $t('home.signIn') }}</span><div class="arrow-right"><arrow-right class="arrow"/></div></div></mpx-view></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m72216026"}'>
.login-control
  width 584rpx
  height 99rpx
  margin 8rpx auto 0 auto
  padding 0 51rpx
  background-image linear-gradient(180deg, rgba(206, 46, 0, 0.58) 0%, rgba(205, 46, 0, 0.51) 100%)
  border-radius 20rpx
  border 2rpx solid rgba(255, 233, 183, 0.3)
  display flex
  flex-flow row nowrap
  justify-content flex-start
  align-items center
.left, .right
  flex 1
  display flex
  flex-flow row nowrap
  justify-content flex-start
  align-items center
.right
  justify-content flex-end
.label
  color #fff
  font-size 28rpx
  font-weight $fw-medium
  line-height 1
.arrow-right
  margin-left 8rpx
  height 32rpx
  line-height 1
  .arrow
    width 9rpx
    height 16rpx

body.en-us
  .login-control
    .label
      font-size 24rpx
      letter-spacing -1rpx
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import { createComponent } from '@mpxjs/core'
import { login } from '../../lib/webx'

createComponent({
  name: 'LoginControl',
  methods: {
    async onLoginClick() {
      try {
        await login()
        this.triggerEvent('login')
      } catch (error) {}
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "component",
    "",
    "login72216026",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'arrow-right':getComponent(require("../common/arrow-right.mpx?component=true&componentId=arrow-right75d32029")),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
